export const COLORS = {
  WB: {
    bgcolor: "#a73afd",
    color: "#ffffff",
    dark: "#48007c",
  },
  YM: {
    bgcolor: "#eebe00",
    color: "#000",
    dark: "#4e3f00",
  },
  OZON: {
    bgcolor: "#005bff",
    color: "#fff",
    dark: "#002a6e",
  },
  DEFAULT: {
    bgcolor: "grey.900",
    color: "#fff",
    dark: "grey.900",
  },
};
